import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Question } from '@models/question/Question';
import { Response } from '@models/response-api/ResponseApi';

@Injectable({
	providedIn: 'root',
})
export class QuestionService {
	private url = `${environment.hostAPI}/questions`;

  constructor(private http: HttpClient) {}

  getById(id: number) {
    const url = `${this.url}/get-by-id/${id}`;
    return this.http.get<Response>(url);
  }

  save(question: Question) {
    return this.http.post<Response>(this.url, question);
  }

  update(question: Question) {
    return this.http.put<Response>(this.url, question);
  }

  remove(question: Question) {
    const url = `${this.url}?id=${question.id}`;
    return this.http.delete<Response>(url);
  }
}
